import { ActionExtended } from "src/_common/interfaces/ActionExtended";
import { User } from "src/_common/interfaces/models/user";
import { ACTIONS, STORAGE } from "src/_config";

export interface UserReducer {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  permissions: {
    permissions: any[];
    member_id?: string;
    member_name?: string;
    member_email?: string;
    role_id?: number;
    role_name?: string;
  } | null;
  subscriptionPlan: {
    plans: any[];
    is_billing_info?: boolean;
    current_plan?: string;
  } | null;
  userData: any;
}

const initialState: UserReducer = {
  user: null,
  token: null,
  isAuthenticated: false,
  permissions: null,
  subscriptionPlan: null,
  userData: null,
};

const userReducer = (state = initialState, action: ActionExtended) => {
  switch (action.type) {
    case ACTIONS.USER.LOGIN:
      const newState = {
        ...state,
        user: action.payload.user,
        token: action.payload.token,
        isAuthenticated: action.payload?.token ? true : false,
      };

      return newState;
    case ACTIONS.USER.LOGOUT:
      localStorage.removeItem(STORAGE);
      return {
        ...state,
        user: null,
        token: null,
        isAuthenticated: false,
        permissions: null,
        subscriptionPlan: null,
      };
    case ACTIONS.USER.ME:
      return {
        ...state,
        user: action.payload,
        isAuthenticated: true,
      };

    case ACTIONS.USER.UPDATE_DISPLAY_NAME:
      let displayName = action.payload;
      let editedUser: any = { ...state.user };
      editedUser["display_name"] = displayName;
      return {
        ...state,
        user: editedUser,
      };

    case ACTIONS.USER.SET_PERMISSIONS:
      return {
        ...state,
        permissions: action.payload,
      };

    case ACTIONS.USER.CLEAR_PERMISSIONS:
      return {
        ...state,
        permissions: null,
      };

    case ACTIONS.USER.SET_USER_DATA:
      return {
        ...state,
        userData: action.payload,
      };

    default:
      return state;
  }
};

export default userReducer;
